import React from 'react';
import './GlassImage.css';

export default function GlassImage({ src, alt = '', video = false, className = '' }) {
  if (!src) return null;

  return (
    <div className={`glass-image ${className}`.trim()}>
      <div className="glass-image-media">
        {video ? (
          <video src={src} autoPlay loop muted playsInline preload="auto" />
        ) : (
          <img src={src} alt={alt} decoding="async" />
        )}
      </div>
      <div className="glass-image-glow" aria-hidden="true" />
    </div>
  );
}
